module.exports = __webpack_public_path__ + "static/DSC_9403-7998c7bcd4bacb022208beae477b79e3.jpg";